import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateForm, generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../HoTroKyThuatChuyenMon";
import {Formik, Form} from "formik";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import {OctTable} from "@oceantech/oceantech-ui";
import {searchdsCanBo} from "../services/services";
import {CODE, TYPE_WH} from "../../../../utils/Constant";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {addPhieuKeHoach, updatePhieuKeHoach} from "../../co-so-kb-cb/services/services";
import {toast} from "react-toastify";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  type: TypeKeHoach;
}

const  DialogPhieuNghiemThu = (props: Props) => {
  const {show, onHide, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values[type?.formThongTinChung],
      type: TYPE_WH.EXPORT,
      doCreation: values?.[type?.formThongTinChung]?.id ? formatDateDTO(values?.[type?.formThongTinChung]?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };
    try {
      setIsLoading(true);
      const id = values[type?.formThongTinChung]?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        toast.success(((id) ? "Cập nhật" : "Thêm") + " thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [dsItems, setDsItems] = useState<any>([]);

  const getDsItems = async () => {
    try {
      const data = await searchdsCanBo(initialValues?.slipId);
      setDsItems(data?.data?.data)
    } catch (e) {

    }
  }

  useEffect(() => {
    initialValues?.slipId && getDsItems();
  }, [initialValues?.slipId]);

  useEffect(() => {
    updateForm();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues, hospitalName: initialValues?.slip?.hospitalName})
  };


  const columns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
  ];
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type.formThongTinChung]: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, type.formThongTinChung)}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={type.name}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <h4 className="text-title fw-bold fs-5 spaces mb-5 mt-5">
                    Cán bộ hỗ trợ kĩ thuật chuyên môn
                  </h4>

                  <OctTable
                    id="table-tt-nhap-thuoc"
                    className={`spaces custom-header-table table-nhan-luc`}
                    columns={columns}
                    data={dsItems}
                    noToolbar
                    clearToolbar
                    noPagination
                    fixedColumnsCount={-1}
                  />
                  <hr/>
                  <GenerateFormComponent
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    modelID={type.formThongTinChung}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    tracker={type.trackerCode}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogPhieuNghiemThu;
